// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-logs {
  padding: 24px;
  max-width: 1400px;
}

.logs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.logs-header h2 {
  margin: 0;
  color: #333;
}

.logs-filters {
  display: flex;
  gap: 10px;
}

.filter-input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.filter-input:focus {
  outline: none;
  border-color: #1976d2;
}

.logs-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  color: #666;
  font-size: 14px;
}

.logs-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.logs-table {
  width: 100%;
  border-collapse: collapse;
}

.logs-table thead {
  background: #f5f5f5;
}

.logs-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #ddd;
  font-size: 14px;
}

.logs-table td {
  padding: 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.logs-table tbody tr:hover {
  background: #f9f9f9;
}

.action-badge {
  display: inline-block;
  padding: 4px 8px;
  background: #e3f2fd;
  color: #1976d2;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.details-dropdown {
  cursor: pointer;
}

.details-dropdown summary {
  color: #1976d2;
  font-size: 12px;
  cursor: pointer;
}

.details-dropdown summary:hover {
  text-decoration: underline;
}

.details-dropdown pre {
  margin-top: 8px;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 12px;
  max-width: 400px;
  overflow-x: auto;
}

.no-logs {
  text-align: center;
  padding: 40px;
  color: #999;
}

.logs-loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

.logs-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.logs-pagination button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.logs-pagination button:hover:not(:disabled) {
  background: #f5f5f5;
}

.logs-pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

`, "",{"version":3,"sources":["webpack://./src/admin/pages/SystemLogs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".system-logs {\n  padding: 24px;\n  max-width: 1400px;\n}\n\n.logs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.logs-header h2 {\n  margin: 0;\n  color: #333;\n}\n\n.logs-filters {\n  display: flex;\n  gap: 10px;\n}\n\n.filter-input {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.filter-input:focus {\n  outline: none;\n  border-color: #1976d2;\n}\n\n.logs-info {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  color: #666;\n  font-size: 14px;\n}\n\n.logs-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n.logs-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.logs-table thead {\n  background: #f5f5f5;\n}\n\n.logs-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #ddd;\n  font-size: 14px;\n}\n\n.logs-table td {\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n}\n\n.logs-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.action-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  background: #e3f2fd;\n  color: #1976d2;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.details-dropdown {\n  cursor: pointer;\n}\n\n.details-dropdown summary {\n  color: #1976d2;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.details-dropdown summary:hover {\n  text-decoration: underline;\n}\n\n.details-dropdown pre {\n  margin-top: 8px;\n  padding: 8px;\n  background: #f5f5f5;\n  border-radius: 4px;\n  font-size: 12px;\n  max-width: 400px;\n  overflow-x: auto;\n}\n\n.no-logs {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n}\n\n.logs-loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.logs-pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.logs-pagination button {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.logs-pagination button:hover:not(:disabled) {\n  background: #f5f5f5;\n}\n\n.logs-pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
